import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('publish-poll', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('publish-poll');

      return new ViewModel(params, element);
    },
  },
  template: html,
});